import axios from 'axios';
import { storage } from '../utils';
import type { CreateAudioRequest, UpdateAudioRequest } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

const getAuthHeaders = () => {
  const token = storage.getToken();
  return {
    Authorization: `Bearer ${token}`,
  };
};

export interface AudioSearchParams {
  type?: 'music' | 'sound_effect';
  category?: string;
  status?: string;
  search?: string;
  pageSize?: number;
  pageIndex?: number;
  sortBy?: string;
}

export const audioLibraryApi = {
  findMany: async (params: AudioSearchParams = {}) => {
    const response = await axios.get(`${API_BASE_URL}/api/v1/admin/audio`, {
      params,
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  findById: async (id: string) => {
    const response = await axios.get(`${API_BASE_URL}/api/v1/admin/audio/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  createAudio: async (file: File, data: CreateAudioRequest) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('data', JSON.stringify(data));

    const response = await axios.post(`${API_BASE_URL}/api/v1/admin/audio`, formData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  updateAudio: async (id: string, data: UpdateAudioRequest) => {
    const response = await axios.patch(`${API_BASE_URL}/api/v1/admin/audio/${id}`, data, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  deleteAudio: async (id: string) => {
    const response = await axios.delete(`${API_BASE_URL}/api/v1/admin/audio/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  restoreAudio: async (id: string) => {
    const response = await axios.post(`${API_BASE_URL}/api/v1/admin/audio/${id}/restore`, {}, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  analyzeAudio: async (id: string) => {
    const response = await axios.post(`${API_BASE_URL}/api/v1/admin/audio/${id}/analyze`, {}, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },
};

export default audioLibraryApi;
